var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline"},[(!_vm.$slots.default)?_vm._t("default",null,{"currencyValue":_vm.slotValue}):[_vm._v("\n    "+_vm._s(_vm.slotValue)+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }